import { PriceOverrideStatus } from "@classes-service-types/price-override-status.ts";

export const BULK_UPDATE_STATUS_OPTIONS = [
  { label: "Approve", value: PriceOverrideStatus.Approved },
  { label: "Decline", value: PriceOverrideStatus.Rejected },
];
